// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "e-svg.owner{--fill: #ffb600}e-svg.admin{--fill: #ececec}e-svg.ban{--fill: #ff0000}e-svg.accept{--fill: #23e900}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
